import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const KVKKKosullari = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h2>Kişisel Verilerin Korunması Kanunu (KVKK) Politikası</h2>
                <div className="legal-content">
                <p><strong>Son Güncelleme:</strong> 01/01/2025</p>

                <p>Güvenliğiniz bizim için önemlidir. Bu sebeple bizimle paylaşacağınız kişisel verileriniz hassasiyetle korunmaktadır.</p>

                <h3>1. Veri Sorumlusu</h3>
                <p>Biz, <strong>Black owLs Gaming Community</strong> olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında "veri sorumlusu" sıfatıyla, kişisel verilerinizin şu ilkeler doğrultusunda işlenmesini sağlamaktayız:</p>
                <ul>
                    <li>Hukuka ve dürüstlük kurallarına uygunluk</li>
                    <li>Doğruluk ve güncellik</li>
                    <li>Belirli, açık ve meşru amaçlar için işlenme</li>
                    <li>İşlenme amacıyla bağlantılı, sınırlı ve ölçülü olma</li>
                    <li>İlgili mevzuatta öngörülen veya işlenme amacı için gerekli olan süre kadar muhafaza edilme</li>
                </ul>

                <h3>2. Toplanan Kişisel Verileriniz, Toplanma Yöntemi ve Hukuki Sebebi</h3>
                <p>Toplanan kişisel verileriniz şunlardır:</p>
                <ul>
                    <li><strong>IP adresi</strong> ve <strong>kullanıcı aracı bilgileri</strong></li>
                </ul>

                <p>Bu veriler, yalnızca analiz yapmak amacıyla çerezler (cookies) gibi teknolojiler kullanılarak otomatik veya otomatik olmayan yöntemlerle işlenir.</p>

                <h3>3. Kişisel Verilerinizin İşlenme Amacı</h3>
                <p>Paylaştığınız kişisel verileriniz;</p>
                <ul>
                    <li>Sunulan hizmetlerin gerekliliklerini en iyi şekilde yerine getirebilmek,</li>
                    <li>Bu hizmetlere sizin tarafınızdan erişilmesini ve maksimum düzeyde faydalanılabilmesini sağlamak,</li>
                    <li>Hizmetlerimizi geliştirebilmek ve kişiselleştirebilmek,</li>
                    <li>Yasal zorunlulukları yerine getirmek amacıyla işlenmektedir.</li>
                </ul>

                <h3>4. Toplanan Kişisel Verilerin Kimlere ve Hangi Amaçlarla Aktarılabileceği</h3>
                <ul>
                    <li>Faaliyetlerimizi yürütmek için hizmet aldığımız tedarikçiler,</li>
                    <li>İş birliği yaptığımız kurum ve kuruluşlar,</li>
                    <li>Kanunen yetkili kamu kurum ve kuruşuları,</li>
                    <li>Adli ve idari makamlar.</li>
                </ul>

                <h3>5. Kişisel Verileri İşlenen Kişi Olarak Haklarınız</h3>
                <p>KVKK'nın 11. maddesi kapsamında veri sahipleri olarak aşağıdaki haklara sahipsiniz:</p>
                <ul>
                    <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
                    <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
                    <li>Kişisel verilerinizin işlenme amacını öğrenme,</li>
                    <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
                    <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
                    <li>Kişisel verilerinizin silinmesini veya yok edilmesini isteme,</li>
                    <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramışsanız tazminat talep etme hakkına sahipsiniz.</li>
                </ul>

                <p>Bu haklarınızı kullanmak için <a href="mailto:blackowlsresmi@gmail.com">blackowlsresmi@gmail.com</a> adresinden bizimle iletişime geçebilirsiniz.</p>

                <h3>6. İletişim</h3>
                <p>Kişisel verilerinizin işlenmesi konusunda tercih size aittir. Web sitemizi kullanmaya devam ettiğiniz takdirde bu KVKK Kullanım Politikasını kabul ettiğiniz tarafımızca varsayılacak olup, daha ayrıntılı bilgi almak için <a href="mailto:blackowlsresmi@gmail.com">blackowlsresmi@gmail.com</a> adresi üzerinden bizimle iletişime geçmekten lütfen çekinmeyiniz.</p>
                </div>
            </div>
        </div>
    );
};

export default KVKKKosullari;